{
  "it": {
    "messages": {
      "loading": "Caricamento…",
      "copy": {
        "success": "Testo copiato!",
        "failure": "Impossibile copiare il Testo"
      },
      "copyGitRevision": {
        "success": "Revisione Git Copiata!",
        "failure": "Impossibile copiare la revisione di Git"
      },
      "copyImageUrl": {
        "success": "Url Immagine Copiato!",
        "failure": "Impossibile copiare l'URL dell'immagine"
      },
      "copyVideoUrl": {
        "success": "Url Video Copiato!",
        "failure": "Impossibile copiare l'URL del Video"
      },
      "copyShareUrl": {
        "success": "URL \"%{url}\" Copiato!",
        "failure": "Impossibile copiare l'URL"
      },
      "copyInviteUrl": {
        "success": "L'URL \"%{url}\" d'invito Copiato!",
        "failure": "Impossibile copiare l'URL dell'invito"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "Url Copiato!",
        "failure": "Impossibile copiare l'Url"
      },
      "copyBackupCodes": {
        "success": "Codici Backup Copiati!",
        "failure": "Impossibile copiare i codici di backup"
      },
      "signup": {
        "success": "<b>Benvenuto su FleetYards.net!</b> Il tuo account è stato creato. <br>Riceverai un'email di conferma per attivare il tuo account.",
        "invalid": "Si prega di risolvere gli errori prima che il tuo account possa essere creato.",
        "failure": "Impossibile creare un nuovo account. Riprova più tardi."
      },
      "accountConfirm": {
        "success": "Il tuo account è stato confermato con successo.<br>Ora puoi effettuare il login.",
        "failure": "Non é stato possibile confermare il tuo account."
      },
      "requestPasswordChange": {
        "success": "Se la tua email esiste nel nostro database, entro qualche minuto riceverai un messaggio email contenente un link per il ripristino della password."
      },
      "changePassword": {
        "success": "Password modificata correttamente.",
        "failure": "La tua password non può essere cambiata."
      },
      "updateProfile": {
        "success": "Profilo aggiornato.",
        "failure": "Il profilo non può essere aggiornato."
      },
      "updateHangar": {
        "failure": "Impossibile aggiornare le impostazioni dell'hangar.",
        "success": "Impostazioni Hangar aggiornate."
      },
      "updatePrivacy": {
        "success": "Impostazioni sulla privacy aggiornate."
      },
      "features": {
        "updated": "Funzione aggiornata.",
        "error": "Impossibile aggiornare la funzione.",
        "actorAdded": "Attore aggiunto alla funzione.",
        "actorRemoved": "Attore rimosso dalla funzione.",
        "groupAdded": "Gruppo aggiunto alla funzione.",
        "groupRemoved": "Gruppo rimosso dalla funzione.",
        "created": "Funzione creata.",
        "destroyed": "Funzione rimossa."
      },
      "rsiRequestLogs": {
        "resolved": "Log delle richieste contrassegnato come risolto.",
        "error": "Impossibile aggiornare il log delle richieste."
      },
      "updateNotifications": {
        "success": "Impostazioni notifiche aggiornate.",
        "failure": "Non è stato possibile salvare le tue impostazioni di notifica."
      },
      "pushNotifications": {
        "failure": "Non è stato possibile aggiornare le notifiche push."
      },
      "updateAccount": {
        "success": "Account aggiornato."
      },
      "oauthApplications": {
        "create": {
          "success": "Applicazione OAuth creata.",
          "error": "Impossibile creare l'applicazione OAuth."
        },
        "update": {
          "success": "Applicazione OAuth aggiornata.",
          "error": "Impossibile aggiornare l'applicazione OAuth."
        },
        "destroy": {
          "success": "Applicazione OAuth eliminata.",
          "error": "Impossibile eliminare l'applicazione OAuth."
        },
        "regenerateSecret": {
          "success": "Segreto client rigenerato.",
          "error": "Impossibile rigenerare il segreto client."
        },
        "copied": "Copiato negli appunti.",
        "copyError": "Impossibile copiare negli appunti.",
        "secretWarning": "Copia il tuo segreto client ora. Non potrai vederlo di nuovo."
      },
      "hangarImport": {
        "success": "Importazione completata",
        "partialSuccess": "Importazione parzialmente completata.<br><br>Navi non trovate: <br>%{missing}",
        "failure": "Importazione fallita",
        "queued": "Importazione in coda. Puoi seguirla qui."
      },
      "hangarExport": {
        "failure": "Esportazione fallita. Per favore riprova più tardi."
      },
      "vehicle": {
        "move": {
          "failure": "Impossibile salvare l'ordine."
        },
        "add": {
          "success": {
            "noHtml": "La tua nuova %{model} sarà consegnata al tuo Hangar",
            "paragraph1": "La tua nuova ",
            "paragraph2": "sarà consegnata al tuo "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "La tua nuova %{model} è stata aggiunta alla tua Lista dei Desideri",
            "paragraph2": "è stata aggiunta alla tua "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "Tutte le navi acquistate in-game sono state spostate nella tua Lista dei Desideri.",
            "failure": "Impossibile spostare tutte le navi acquistate in-game nella tua Lista dei Desideri."
          },
          "removeAll": {
            "success": "Tutte le navi acquistate in-game sono state rimosse dal tuo Hangar.",
            "failure": "Impossibile rimuovere tutte le navi acquistate in-game dal tuo Hangar."
          }
        }
      },
      "model": {
        "onSale": "%{model} è ora in vendita!",
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "Importazione delle verniciature avviata. Riceverai una notifica al termine.",
        "dimensionsDrifted": "Queste dimensioni differiscono dai file di gioco."
      },
      "announcement": {
        "created": "Annuncio creato.",
        "updated": "Annuncio aggiornato.",
        "destroyed": "Annuncio eliminato.",
        "destroyFailed": "Impossibile eliminare l'annuncio.",
        "createFailed": "Impossibile creare l'annuncio.",
        "updateFailed": "Impossibile aggiornare l'annuncio.",
        "testSent": "Test inviato al canale Discord di amministrazione.",
        "testFailed": "Impossibile inviare il test.",
        "published": "L'annuncio è in viaggio.",
        "publishFailed": "Impossibile inviare l'annuncio.",
        "retryQueued": "Consegna rimessa in coda.",
        "retryFailed": "Impossibile riprovare questa consegna.",
        "refreshQueued": "I numeri sono in aggiornamento.",
        "refreshFailed": "Impossibile aggiornare i numeri."
      },
      "fundingGoal": {
        "created": "Obiettivo di finanziamento creato.",
        "updated": "Obiettivo di finanziamento aggiornato.",
        "destroyed": "Obiettivo di finanziamento eliminato.",
        "createFailed": "Non è stato possibile creare l'obiettivo di finanziamento.",
        "updateFailed": "Non è stato possibile aggiornare l'obiettivo di finanziamento."
      },
      "supporterNomination": {
        "update": {
          "success": "Selezione della flotta aggiornata.",
          "failure": "Impossibile aggiornare la selezione della flotta."
        },
        "change": {
          "confirm": "%{fleet} potrebbe perdere le funzioni di flotta di cui dispone ora. Continuare?"
        }
      },
      "supporterContribution": {
        "created": "Contributo del sostenitore creato.",
        "updated": "Contributo del sostenitore aggiornato.",
        "destroyed": "Contributo del sostenitore eliminato.",
        "createFailed": "Non è stato possibile creare il contributo del sostenitore.",
        "updateFailed": "Non è stato possibile aggiornare il contributo del sostenitore."
      },
      "notification": {
        "granted": "Benvenuto nelle notifiche FleetYards.net!"
      },
      "twoFactor": {
        "enable": {
          "success": "Autenticazione a due fattori attivata!",
          "failure": "Impossibile abilitare l'autenticazione a due fattori."
        },
        "disable": {
          "success": "Autenticazione a due fattori disattivata!",
          "failure": "Impossibile disattivare l'autenticazione a due fattori."
        },
        "backupCodes": {
          "failure": "Impossibile generare i codici di Backup."
        }
      },
      "error": {
        "usernameTaken": "Il nome utente è già in uso.",
        "userNotFound": "Utente non trovato",
        "emailTaken": "Email già utilizzata.",
        "fleetTaken": "Nome Flotta già in uso.",
        "colorInvalid": "Il colore non è valido",
        "serialTaken": "Seriale già in uso.",
        "textInvalid": "%{field} non è valido",
        "fleetNameInvalid": "Il campo %{field} può contenere solo caratteri alfanumerici, spazi, punti, trattini e trattini bassi",
        "hangar": {
          "accountRequired": {
            "noHtml": "Devi registrarti o effettuare il login per aggiungere navi al tuo Hangar.",
            "paragraph1": "Devi ",
            "paragraph2": " per aggiungere navi al tuo Hangar.",
            "paragraph3": "Ottieni più informazioni "
          }
        },
        "blueprint": {
          "accountRequired": "Registrati o accedi per tenere traccia dei progetti che possiedi.",
          "own": "Non è stato possibile aggiornare il progetto. Riprova."
        },
        "default": "<b>Si è verificato un errore.</b> <br>Hai provato a spegnere e riaccendere?"
      },
      "account": {
        "destroy": {
          "success": "<b>Il tuo account è stato distrutto.</b> <br>È un peccato vederti andare :'(",
          "failure": "Impossibile eliminare il tuo account. Riprova più tardi."
        },
        "calendarSubscription": {
          "enable": {
            "success": "Sottoscrizione al calendario personale attivata.",
            "failure": "Non è stato possibile attivare la sottoscrizione al calendario."
          },
          "rotate": {
            "success": "Link del calendario personale rigenerato. Chi era già iscritto smetterà di ricevere aggiornamenti finché non si iscriverà di nuovo.",
            "failure": "Non è stato possibile rigenerare il link del calendario personale.",
            "confirm": "Rigenerando il link, qualsiasi app calendario iscritta all'URL attuale smetterà di funzionare senza preavviso. Dovrai iscriverti di nuovo con il nuovo link."
          },
          "disable": {
            "success": "Sottoscrizione al calendario personale disattivata.",
            "failure": "Non è stato possibile disattivare la sottoscrizione al calendario personale.",
            "confirm": "Disattivando la sottoscrizione interromperai il feed per tutte le app calendario attualmente iscritte."
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "Chiave copiata.",
            "failure": "Impossibile copiare la chiave."
          }
        }
      },
      "user": {
        "destroy": {
          "success": "Utente eliminato.",
          "failure": "Non è stato possibile eliminare l'utente."
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "Rivendicazione aperta. La flotta che ha l’ID è stata avvisata.",
            "failure": "Non è stato possibile rivendicare l’ID flotta."
          },
          "destroy": {
            "success": "Rivendicazione ritirata.",
            "failure": "Non è stato possibile ritirare la rivendicazione."
          },
          "endNow": {
            "success": "Periodo di tolleranza terminato.",
            "failure": "Non è stato possibile terminare il periodo di tolleranza."
          },
          "cancel": {
            "success": "Rivendicazione annullata.",
            "failure": "Non è stato possibile annullare la rivendicazione."
          }
        },
        "create": {
          "success": "La tua Flotta è stata creata.",
          "failure": "Non è stato possibile salvare la Flotta."
        },
        "update": {
          "success": "Impostazioni salvate.",
          "failure": "Le impostazioni non possono essere salvate."
        },
        "destroy": {
          "success": "La tua Flotta è stata distrutta.",
          "failure": "Non siamo riusciti a distruggere la tua Flotta."
        },
        "leave": {
          "success": "Hai lasciato la Flotta.",
          "failure": "Impossibile lasciare la Flotta."
        },
        "invites": {
          "accept": {
            "success": "Invito accettato.",
            "failure": "Impossibile accettare l'invito."
          },
          "decline": {
            "success": "Invito rifiutato.",
            "failure": "Impossibile rifiutare l'invito."
          },
          "create": {
            "failure": "Impossibile invitare l'utente."
          }
        },
        "members": {
          "update": {
            "success": "Impostazioni salvate.",
            "failure": "Le impostazioni non possono essere salvate."
          },
          "destroy": {
            "success": "Membro rimosso.",
            "failure": "Il membro non può essere rimosso."
          },
          "demote": {
            "success": "Membro degradato.",
            "failure": "Il membro non può essere degradato."
          },
          "promote": {
            "success": "Membro promosso.",
            "failure": "Il membro non può essere promosso."
          },
          "accept": {
            "success": "Membro accettato.",
            "failure": "Il membro non può essere accettato."
          },
          "decline": {
            "success": "Membro respinto.",
            "failure": "Il membro non può essere respinto."
          },
          "nickname": {
            "success": "Soprannome salvato.",
            "failure": "Impossibile salvare il soprannome."
          }
        },
        "roles": {
          "update": {
            "success": "Ruolo salvato.",
            "failure": "Non è stato possibile salvare il ruolo."
          }
        },
        "squadrons": {
          "create": {
            "success": "Squadrone creato.",
            "failure": "Impossibile creare lo squadrone."
          },
          "update": {
            "success": "Squadrone salvato.",
            "failure": "Impossibile salvare lo squadrone."
          },
          "destroy": {
            "confirm": "Sciogliere lo squadrone «%{name}»? I suoi membri restano nella flotta.",
            "success": "Squadrone sciolto.",
            "failure": "Impossibile sciogliere lo squadrone."
          },
          "sort": {
            "failure": "Non è stato possibile salvare l'ordine."
          },
          "ranks": {
            "update": {
              "success": "Gradi di squadrone salvati.",
              "failure": "Non è stato possibile salvare i gradi di squadrone."
            }
          },
          "members": {
            "add": {
              "success": "%{count} membri aggiunti.",
              "failure": "Impossibile aggiungere %{count} membri."
            },
            "destroy": {
              "confirm": "Rimuovere %{username} dallo squadrone %{squadron}? Resterà nella flotta.",
              "success": "Membro rimosso dallo squadrone.",
              "failure": "Non è stato possibile rimuovere il membro."
            }
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "Sottoscrizione al calendario attivata.",
            "failure": "Non è stato possibile attivare la sottoscrizione al calendario."
          },
          "rotate": {
            "success": "Link di sottoscrizione rigenerato. Chi era già iscritto smetterà di ricevere aggiornamenti finché non si iscriverà di nuovo.",
            "failure": "Non è stato possibile rigenerare il link di sottoscrizione.",
            "confirm": "Rigenerando il link, qualsiasi app calendario iscritta all'URL attuale smetterà di funzionare senza preavviso. Dovranno iscriversi di nuovo con il nuovo link."
          },
          "disable": {
            "success": "Sottoscrizione al calendario disattivata.",
            "failure": "Non è stato possibile disattivare la sottoscrizione al calendario.",
            "confirm": "Disattivando la sottoscrizione interromperai il feed per tutte le app calendario attualmente iscritte."
          },
          "copy": {
            "success": "Link del calendario copiato. Incollalo nella tua app calendario sotto \"Iscriviti a un calendario\" o \"Aggiungi tramite URL\".",
            "failure": "Non è stato possibile copiare il link del calendario."
          }
        }
      },
      "fleetInvite": {
        "used": "<b>Richiesta di partecipazione a %{fleet} inviata!</b><br>Una volta che la tua iscrizione sarà accettata, sarai avvisato via email",
        "failure": "L'invito non può essere usato.",
        "confirm": "Sei sicuro di voler partecipare alla Flotta: \"%{fleet}\"?"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "Non è stato possibile caricare il modello 3D richiesto! Riprova più tardi."
        },
        "webglNotSupported": "Il visualizzatore 3D non è disponibile su questo dispositivo."
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicle": {
          "destroy": "Sei sicuro di voler rimuovere questa Nave dall'Hangar?"
        },
        "hangarGroup": {
          "destroy": "Sei sicuro di voler rimuovere questo Gruppo dall'Hangar?"
        },
        "hangar": {
          "import": "Le navi importate saranno aggiunte al tuo Hangar senza corrispondere alle navi già presenti.<br><br>Formati supportati sono: Fleetyards Export o HangarXplor.<br><br>Vuoi continuare?",
          "destroySelected": "Sei sicuro di voler rimuovere tutte le navi selezionate dall'Hangar? Questa azione non può essere annullata.",
          "destroyAll": "Sei sicuro di voler rimuovere tutte le navi dall'Hangar? Questa azione non può essere annullata."
        },
        "wishlist": {
          "destroyAll": "Sei sicuro di voler rimuovere tutte le navi dalla tua Lista dei Desideri? Questa azione non può essere annullata."
        },
        "account": {
          "destroy": "Sei sicuro di voler eliminare il tuo account? Questa azione non potrà essere annullata.",
          "destroyWithFleets": "Sei l'amministratore della/e seguente/i Flotta/e: %{fleets}. Eliminando il tuo account verranno eliminate anche queste Flotte e rimossi tutti i loro membri. Questa azione non può essere annullata. Vuoi continuare?"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "Sei sicuro di voler lasciare questa Flotta? Questa azione non potrà essere annullata.",
          "destroy": "Sei sicuro di voler eliminare la tua Flotta? Questa azione non potrà essere annullata.",
          "members": {
            "destroy": "Sei sicuro di voler rimuovere questo membro?",
            "remove": "Sei sicuro di voler rimuovere questo membro dalla flotta?"
          },
          "invites": {
            "decline": "Sei sicuro di voler rifiutare questo invito? Questa azione non potrà essere annullata."
          }
        },
        "oauthApplication": {
          "destroy": "Sei sicuro di voler eliminare questa applicazione OAuth? Questa azione non può essere annullata.",
          "regenerateSecret": "Sei sicuro di voler rigenerare il segreto client? Le integrazioni esistenti smetteranno di funzionare."
        },
        "twoFactor": {
          "generateBackupCodes": "Sei sicuro di voler rigenerare i tuoi codici di backup per l'autenticazione a due fattori?"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "Questo utente è l'amministratore della/e seguente/i Flotta/e: %{fleets}. Eliminando l'utente verranno eliminate anche queste Flotte e rimossi tutti i loro membri. Questa azione non può essere annullata. Vuoi continuare?"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "Sei sicuro di voler importare le verniciature di questo modello dai dati dell'hangar? Una verniciatura che la fonte indica per un'intera serie viene importata per ogni modello di quella serie.",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "Sei sicuro di voler ricaricare le verniciature? Questo metterà in coda dei processi in background.",
          "reloadModules": "Sei sicuro di voler ricaricare i moduli? Questo metterà in coda dei processi in background.",
          "reloadLoaners": "Sei sicuro di voler ricaricare le navi in comodato? Questo metterà in coda dei processi in background."
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "announcement": {
          "publish": "Inviare questo annuncio a %{channels}? Non si può annullare.",
          "destroy": "Vuoi davvero eliminare questo annuncio? L'azione non è reversibile."
        },
        "fundingGoal": {
          "destroy": "Sei sicuro di voler eliminare questo obiettivo di finanziamento? Questa azione non può essere annullata."
        },
        "supporterContribution": {
          "destroy": "Sei sicuro di voler eliminare questo contributo del sostenitore? Questa azione non può essere annullata."
        },
        "modelPosition": {
          "destroy": "Sei sicuro di voler eliminare questa posizione? Questa azione non può essere annullata."
        },
        "modelLoaner": {
          "destroy": "Sei sicuro di voler eliminare questo prestito? Questa azione non può essere annullata."
        },
        "modelSnubCraft": {
          "destroy": "Sei sicuro di voler eliminare questo snub craft? Questa azione non può essere annullata."
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dockCapacity": {
          "destroy": "Vuoi davvero eliminare questa voce di capacità? L'azione non può essere annullata."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "Sei sicuro di voler eliminare tutte le notifiche? Questa azione non può essere annullata.",
          "destroySelected": {
            "one": "Sei sicuro di voler eliminare la notifica selezionata? Questa azione non può essere annullata.",
            "other": "Sei sicuro di voler eliminare le %{count} notifiche selezionate? Questa azione non può essere annullata."
          }
        },
        "adminFleetFidClaim": {
          "endNow": "Terminare ora il periodo di tolleranza? La flotta che ha l’ID viene rinominata e quella che lo rivendica lo riceve subito.",
          "cancel": "Annullare questa rivendicazione? Entrambe le flotte vengono avvisate, e quella che ha l’ID lo tiene."
        },
        "fleetFidClaim": {
          "create": "Rivendicare l’ID flotta %{fid}? La flotta che lo ha viene avvisata ora e perde l’ID tra 14 giorni, a meno che non dimostri lei stessa l’organizzazione RSI."
        },
        "adminDestroyedFleet": {
          "restore": "Sei sicuro di voler ripristinare questa flotta?",
          "restorePurged": "Sei sicuro di voler ripristinare questa flotta eliminata definitivamente? Il ripristino è parziale: ruoli, immagini, link di invito e veicoli della flotta non vengono ripristinati."
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "Sei sicuro di voler eliminare tutte le notifiche? Questa azione non può essere annullata.",
          "destroySelected": {
            "one": "Sei sicuro di voler eliminare la notifica selezionata? Questa azione non può essere annullata.",
            "other": "Sei sicuro di voler eliminare le %{count} notifiche selezionate? Questa azione non può essere annullata."
          }
        },
        "unlistedModel": {
          "createModel": "Creare una nave da %{name}? Il prossimo caricamento sc_data completerà le sue meccaniche."
        },
        "import": {
          "cleanup": "Segnare questa importazione come fallita? Fallo solo se il job è davvero sparito: un'esecuzione ancora attiva darà errore al termine.",
          "cleanupSelected": "Segnare come fallite le importazioni selezionate? Riguarda solo quelle ancora in corso, e un'esecuzione davvero ancora attiva darà errore al termine.",
          "cancel": "Interrompere questa importazione? Le navi già aggiunte vengono mantenute."
        },
        "hardpoint": {
          "destroy": "Sei sicuro di voler eliminare questo punto di montaggio? Questa azione non può essere annullata."
        },
        "fleets": {
          "contractItem": {
            "destroy": "Rimuovere queste merci dal contratto?"
          }
        }
      },
      "oauthAuthorize": {
        "loading": "Caricamento...",
        "loadError": "Impossibile caricare i dettagli di autorizzazione.",
        "authorizeError": "Autorizzazione fallita.",
        "denyError": "Il rifiuto dell'autorizzazione è fallito."
      },
      "oauth": {
        "disconnect": {
          "success": "Provider disconnesso con successo.",
          "failure": "Impossibile disconnettere il provider. Riprova."
        }
      },
      "confirmAccess": {
        "failure": "L'accesso non è stato confermato. Controlla la password e riprova."
      },
      "setEmail": {
        "success": "Un'email di conferma è stata inviata al tuo nuovo indirizzo. Controlla la tua casella di posta.",
        "failure": "Impossibile aggiornare l'indirizzo email. Riprova."
      },
      "confirmAccessEmail": {
        "sent": "Un codice di conferma è stato inviato alla tua e-mail.",
        "failure": "Impossibile inviare l'e-mail di conferma. Riprova."
      },
      "confirmAccessCode": {
        "failure": "Il codice di conferma non è valido o è scaduto."
      },
      "import": {
        "started": "Importazione %{type} avviata...",
        "finished": "Importazione %{type} completata con successo.",
        "failed": "Importazione %{type} fallita: %{info}"
      },
      "syncExtension": {
        "started": "Sincronizzazione del tuo Hangar in corso...",
        "success": "Il tuo Hangar è stato sincronizzato.",
        "failure": "Il tuo Hangar non può essere sincronizzato.",
        "notLoggedIn": "Devi essere connesso su <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> per sincronizzare il tuo Hangar."
      },
      "admin": {
        "importLoaders": {
          "started": "%{name} avviato.",
          "failed": "Impossibile avviare %{name}."
        },
        "supporterContributions": {
          "patreonSyncStarted": "Sincronizzazione con Patreon avviata. Aggiorna la pagina tra un minuto per vedere i sostenitori importati."
        },
        "imports": {
          "cleaned": "Importazione segnata come fallita",
          "cleanedUp": {
            "one": "%{count} importazione segnata come fallita",
            "other": "%{count} importazioni segnate come fallite"
          },
          "noneRunning": "Nella selezione non era più in corso nulla",
          "cleanupError": "Non è stato possibile ripulire l'importazione"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "Svuotare il carico di questa nave? Tutte le voci verranno eliminate.",
            "success": "Carico svuotato.",
            "failure": "Impossibile svuotare il carico."
          }
        },
        "transfer": {
          "needsAnswer": "Devono accettarlo prima che arrivi. Le scorte lasciano il tuo inventario ora e tornano se rifiutano.",
          "create": {
            "failure": "Impossibile inviare il trasferimento"
          },
          "resolve": {
            "failure": "Impossibile aggiornare il trasferimento"
          },
          "reportHint": "Segnalare lo rifiuta, restituisce le merci e impedisce a questo mittente di ricontattarti."
        }
      },
      "adminNotifications": {
        "unread": "Notifica segnata come non letta",
        "archived": "Notifica archiviata",
        "unarchived": "Notifica riportata in arrivo",
        "readAll": "Tutte le notifiche segnate come lette",
        "destroyed": "Notifica eliminata",
        "destroyedAll": "Tutte le notifiche eliminate",
        "error": "Qualcosa è andato storto",
        "bulk": {
          "read": {
            "one": "%{count} notifica segnata come letta",
            "other": "%{count} notifiche segnate come lette"
          },
          "unread": {
            "one": "%{count} notifica segnata come non letta",
            "other": "%{count} notifiche segnate come non lette"
          },
          "archived": {
            "one": "%{count} notifica archiviata",
            "other": "%{count} notifiche archiviate"
          },
          "unarchived": {
            "one": "%{count} notifica riportata in arrivo",
            "other": "%{count} notifiche riportate in arrivo"
          },
          "destroyed": {
            "one": "%{count} notifica eliminata",
            "other": "%{count} notifiche eliminate"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "Impostazioni di notifica salvate.",
            "failure": "Non è stato possibile salvare le impostazioni di notifica."
          }
        },
        "mission": {
          "publish": {
            "success": "Missione pubblicata — la flotta può vederla.",
            "failure": "Impossibile pubblicare la missione."
          },
          "create": {
            "success": "Missione creata.",
            "failure": "Non è stato possibile creare la missione."
          },
          "update": {
            "success": "Missione aggiornata.",
            "failure": "Non è stato possibile aggiornare la missione."
          },
          "archive": {
            "success": "Missione archiviata.",
            "failure": "Non è stato possibile archiviare la missione."
          },
          "unarchive": {
            "success": "Missione ripristinata.",
            "failure": "Non è stato possibile ripristinare la missione."
          },
          "destroy": {
            "success": "Missione eliminata.",
            "failure": "Non è stato possibile eliminare la missione.",
            "confirm": "Questo eliminerà definitivamente la missione e tutti i suoi team, navi e slot. Questa azione non può essere annullata."
          }
        },
        "missionTeam": {
          "create": {
            "success": "Team aggiunto.",
            "failure": "Non è stato possibile aggiungere il team."
          },
          "update": {
            "success": "Team aggiornato.",
            "failure": "Non è stato possibile aggiornare il team."
          },
          "destroy": {
            "success": "Team rimosso.",
            "failure": "Non è stato possibile rimuovere il team."
          }
        },
        "missionShip": {
          "create": {
            "success": "Nave aggiunta.",
            "failure": "Non è stato possibile aggiungere la nave."
          },
          "update": {
            "success": "Nave aggiornata.",
            "failure": "Non è stato possibile aggiornare la nave."
          },
          "destroy": {
            "success": "Nave rimossa.",
            "failure": "Non è stato possibile rimuovere la nave."
          },
          "duplicate": {
            "success": "Nave duplicata.",
            "failure": "Non è stato possibile duplicare la nave."
          }
        },
        "missionSlot": {
          "create": {
            "success": "Slot aggiunto.",
            "failure": "Non è stato possibile aggiungere lo slot."
          },
          "update": {
            "success": "Slot aggiornato.",
            "failure": "Non è stato possibile aggiornare lo slot."
          },
          "destroy": {
            "success": "Slot rimosso.",
            "failure": "Non è stato possibile rimuovere lo slot."
          }
        },
        "event": {
          "create": {
            "success": "Evento creato.",
            "failure": "Non è stato possibile creare l'evento."
          },
          "update": {
            "success": "Evento aggiornato.",
            "failure": "Non è stato possibile aggiornare l'evento."
          },
          "archive": {
            "success": "Evento archiviato.",
            "failure": "Non è stato possibile archiviare l'evento.",
            "confirm": "Vuoi archiviare questo evento? I membri non lo vedranno più nell'elenco dei prossimi eventi."
          },
          "unarchive": {
            "success": "Evento ripristinato dall'archivio.",
            "failure": "Non è stato possibile ripristinare l'evento."
          },
          "syncToDiscord": {
            "success": "Evento inviato a Discord.",
            "failure": "Non è stato possibile inviare l'evento a Discord."
          },
          "destroy": {
            "success": "Evento eliminato.",
            "failure": "Non è stato possibile eliminare l'evento.",
            "confirm": "Questo eliminerà definitivamente l'evento. Questa azione non può essere annullata."
          },
          "publish": {
            "success": "Evento pubblicato — le iscrizioni sono ora aperte.",
            "failure": "Non è stato possibile pubblicare l'evento."
          },
          "lockSignups": {
            "success": "Iscrizioni bloccate.",
            "failure": "Non è stato possibile bloccare le iscrizioni."
          },
          "unlockSignups": {
            "success": "Iscrizioni riaperte.",
            "failure": "Non è stato possibile riaprire le iscrizioni."
          },
          "start": {
            "success": "Evento avviato.",
            "failure": "Non è stato possibile avviare l'evento."
          },
          "complete": {
            "success": "Evento segnato come completato.",
            "failure": "Non è stato possibile completare l'evento."
          },
          "cancel": {
            "success": "Evento annullato.",
            "failure": "Non è stato possibile annullare l'evento.",
            "confirm": "Vuoi annullare questo evento? I partecipanti riceveranno una notifica."
          }
        },
        "eventSignup": {
          "create": {
            "success": "Iscrizione effettuata.",
            "failure": "Non è stato possibile completare l'iscrizione."
          },
          "update": {
            "success": "Iscrizione aggiornata.",
            "failure": "Non è stato possibile aggiornare l'iscrizione."
          },
          "withdraw": {
            "success": "Ti sei ritirato dall'evento.",
            "failure": "Non è stato possibile ritirarsi.",
            "confirm": "Vuoi ritirarti da questo evento?"
          },
          "kick": {
            "success": "Iscrizione rimossa.",
            "failure": "Non è stato possibile rimuovere l'iscrizione.",
            "confirm": "Vuoi rimuovere l'iscrizione di questo membro?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "Ruolo assegnato.",
            "failure": "Non è stato possibile assegnare il ruolo."
          },
          "destroy": {
            "success": "Ruolo revocato.",
            "failure": "Non è stato possibile revocare il ruolo.",
            "confirm": "Vuoi revocare il ruolo di %{username} per questo evento?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "Team aggiunto.",
            "failure": "Non è stato possibile aggiungere il team."
          },
          "update": {
            "success": "Team aggiornato.",
            "failure": "Non è stato possibile aggiornare il team."
          },
          "destroy": {
            "success": "Team rimosso.",
            "failure": "Non è stato possibile rimuovere il team.",
            "confirm": "Vuoi rimuovere questo team con tutte le sue navi e slot?"
          }
        },
        "eventShip": {
          "create": {
            "success": "Nave aggiunta.",
            "failure": "Non è stato possibile aggiungere la nave."
          },
          "update": {
            "success": "Nave aggiornata.",
            "failure": "Non è stato possibile aggiornare la nave."
          },
          "destroy": {
            "success": "Nave rimossa.",
            "failure": "Non è stato possibile rimuovere la nave.",
            "confirm": "Vuoi rimuovere questa nave e i suoi slot?"
          }
        },
        "eventSlot": {
          "create": {
            "success": "Slot aggiunto.",
            "failure": "Non è stato possibile aggiungere lo slot."
          },
          "update": {
            "success": "Slot aggiornato.",
            "failure": "Non è stato possibile aggiornare lo slot."
          },
          "destroy": {
            "success": "Slot rimosso.",
            "failure": "Non è stato possibile rimuovere lo slot."
          }
        },
        "contract": {
          "create": {
            "success": "Contratto creato",
            "failure": "Impossibile creare il contratto"
          },
          "update": {
            "success": "Contratto salvato",
            "failure": "Impossibile salvare il contratto"
          },
          "item": {
            "create": {
              "failure": "Impossibile aggiungere le merci"
            },
            "destroy": {
              "failure": "Impossibile rimuovere le merci"
            },
            "update": {
              "failure": "Non è stato possibile modificare le merci"
            }
          }
        },
        "contracts": {
          "deliverHint": "Invia le merci da uno dei tuoi inventari e scegli questo contratto, così la consegna viene conteggiata.",
          "expiredHint": "Questo contratto è scaduto e non accetta nuove consegne. Le consegne già in viaggio contano comunque una volta accettate."
        }
      },
      "notifications": {
        "unread": "Notifica segnata come non letta",
        "archived": "Notifica archiviata",
        "unarchived": "Notifica riportata in arrivo",
        "readAll": "Tutte le notifiche segnate come lette",
        "destroyed": "Notifica eliminata",
        "destroyedAll": "Tutte le notifiche eliminate",
        "actionDone": "Fatto",
        "actionFailed": "Non ha funzionato - la notifica potrebbe non essere più aggiornata",
        "error": "Qualcosa è andato storto",
        "bulk": {
          "read": {
            "one": "%{count} notifica segnata come letta",
            "other": "%{count} notifiche segnate come lette"
          },
          "unread": {
            "one": "%{count} notifica segnata come non letta",
            "other": "%{count} notifiche segnate come non lette"
          },
          "archived": {
            "one": "%{count} notifica archiviata",
            "other": "%{count} notifiche archiviate"
          },
          "unarchived": {
            "one": "%{count} notifica riportata in arrivo",
            "other": "%{count} notifiche riportate in arrivo"
          },
          "destroyed": {
            "one": "%{count} notifica eliminata",
            "other": "%{count} notifiche eliminate"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "Importazione annullata",
          "error": "Impossibile annullare questa importazione"
        }
      },
      "payouts": {
        "entryCreated": "Movimento registrato",
        "entryUpdated": "Movimento aggiornato",
        "entryDestroyed": "Movimento rimosso",
        "participantAdded": "Partecipante aggiunto",
        "participantRemoved": "Partecipante rimosso",
        "participantHasEntries": "Rimuovi prima i suoi movimenti",
        "settled": "Pagamenti calcolati",
        "reopened": "Registro riaperto",
        "tourCreated": "Spedizione creata",
        "tourCreateFailure": "Impossibile creare la spedizione.",
        "tourJoined": "Ti sei unito alla spedizione",
        "settleConfirm": "Calcolare i pagamenti e bloccare il registro? I movimenti non saranno più modificabili fino alla riapertura.",
        "reopenConfirm": "Riaprire il registro? L'elenco pagamenti attuale verrà scartato.",
        "participantNeedsName": "Inserisci un nome utente o un nome",
        "weightUpdated": "Quota aggiornata",
        "joinRequested": "La tua richiesta è stata inviata",
        "joinRequestWithdrawn": "Richiesta ritirata",
        "joinRequestApproved": "Richiesta accettata",
        "joinRequestDeclined": "Richiesta rifiutata",
        "expenseApproved": "Spesa approvata",
        "expenseDeclined": "Spesa rifiutata",
        "pendingReview": "%{count} spesa/e in attesa di verifica"
      },
      "dockAddition": {
        "create": {
          "failure": "Impossibile aggiungere quella nave."
        },
        "destroy": {
          "failure": "Impossibile rimuovere quella nave."
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "Impossibile creare la voce di capacità."
        },
        "update": {
          "failure": "Impossibile salvare la voce di capacità."
        },
        "destroy": {
          "failure": "Impossibile eliminare la voce di capacità."
        }
      },
      "dock": {
        "create": {
          "failure": "Impossibile creare il dock."
        },
        "update": {
          "failure": "Impossibile salvare il dock."
        },
        "destroy": {
          "failure": "Impossibile eliminare il dock."
        }
      },
      "relationships": {
        "user": {
          "addHint": "Inserisci il nome utente della persona da aggiungere. Le verrà chiesto di accettare."
        },
        "fleet": {
          "addHint": "Inserisci l'identificativo della flotta con cui vuoi allearti. I suoi amministratori dovranno accettare."
        }
      },
      "friends": {
        "request": {
          "success": "Richiesta inviata",
          "failure": "Impossibile inviare la richiesta"
        },
        "accept": {
          "success": "Richiesta accettata",
          "failure": "Impossibile accettare la richiesta"
        },
        "decline": {
          "success": "Richiesta rifiutata",
          "failure": "Impossibile rifiutare la richiesta"
        },
        "ignore": {
          "success": "Richiesta ignorata",
          "failure": "Impossibile ignorare la richiesta"
        },
        "remove": {
          "success": "Rimosso",
          "failure": "Impossibile rimuovere"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "Richiesta inviata",
          "failure": "Impossibile inviare la richiesta"
        },
        "accept": {
          "success": "Richiesta accettata",
          "failure": "Impossibile accettare la richiesta"
        },
        "decline": {
          "success": "Richiesta rifiutata",
          "failure": "Impossibile rifiutare la richiesta"
        },
        "ignore": {
          "success": "Richiesta ignorata",
          "failure": "Impossibile ignorare la richiesta"
        },
        "remove": {
          "success": "Rimosso",
          "failure": "Impossibile rimuovere"
        }
      }
    }
  }
}
